import SideBarListComponent from './SideBarListComponent';

export default SideBarListComponent;
